/**
 * iOS Safari only allows audio playback that starts inside a user gesture. Call this synchronously
 * from the Start click handler (before any await) so the later WebRTC audio element can play.
 */
export function unlockAudio(): void {
  try {
    const AudioContextConstructor =
      window.AudioContext ||
      (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioContextConstructor) return;
    const context = new AudioContextConstructor();
    const buffer = context.createBuffer(1, 1, 22_050);
    const source = context.createBufferSource();
    source.buffer = buffer;
    source.connect(context.destination);
    source.start(0);
    void context.resume().then(() => window.setTimeout(() => void context.close(), 500));
  } catch {
    // Best effort only.
  }
}
